<!--  -->
<template>
	<div class="app">
		<div class="body-article-item">
			<div class="body-article-item-left">
				<div class="body-article-h1" @click="toiInfoDetail(item.id,$event)">{{item.title}}</div>
				<div class="body-article-h2">{{item.desc}}</div>
				<div class="body-article-botton">
					<div class="row">
						<div class="body-article-botton-h1">发布：{{item.publish_name}}</div>
						<div class="body-article-botton-h2">{{item.create_time}}</div>
						<div class="body-article-botton-h3">
							<img src="../img/eye.png" alt />
							<div>{{item.hot}}</div>
						</div>
					</div>
					<div class="body-article-botton-h4">来自：{{item.cate.title}}</div>
				</div>
			</div>
			<img :src="item.logo" alt class="body-article-item-right" @click="toiInfoDetail(item.id,$event)" />
		</div>
	</div>
</template>

<script>
	//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
	//例如：import 《组件名称》 from '《组件路径》';

	export default {
		//import引入的组件需要注入到对象中才能使用
		components: {},
		props: ["item"],
		data() {
			//这里存放数据
			return {};
		},
		//监听属性 类似于data概念
		computed: {},
		//监控data中的数据变化
		watch: {},
		//方法集合
		methods: {
			toiInfoDetail(id, e) {
				e.srcElement.style.color = "#B2B2B2";
				const InfoDetail = this.$router.resolve({
					path: "/infoDetail",
					query: { id: id }
				});
				window.open(InfoDetail.href, "_blank");
			}
		},
		//生命周期 - 创建完成（可以访问当前this实例）
		created() {},
		//生命周期 - 挂载完成（可以访问DOM元素）
		mounted() {},
		beforeCreate() {}, //生命周期 - 创建之前
		beforeMount() {}, //生命周期 - 挂载之前
		beforeUpdate() {}, //生命周期 - 更新之前
		updated() {}, //生命周期 - 更新之后
		beforeDestroy() {}, //生命周期 - 销毁之前
		destroyed() {}, //生命周期 - 销毁完成
		activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
	};
</script>
<style  scoped>
	.body-article-item {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding: 22px;
	}
	.body-article-item-left {
		width: 630px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}
	.body-article-item-right {
		width: 160px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
	}
	.body-article-h1 {
		color: #212121;
		font-size: 20px;
		font-weight: bold;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 600px;
		cursor: pointer;
	}
	.body-article-h1:active {
		color: #cccccc;
	}
	.body-article-h1:hover {
		color: #28a3b1;
	}
	.body-article-h2 {
		color: #808080;
		font-size: 14px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		position: relative;
		bottom: 2px;
	}
	.row-center {
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.row {
		display: flex;
		flex-direction: row;
	}
	.body-article-botton {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
	}
	.body-article-botton-h2 {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		margin: 0 20px;
	}
	.body-article-botton-h3 {
		display: flex;
		flex-direction: row;
		height: 20px;
		justify-content: center;
		align-items: center;
	}
	.body-article-botton-h3 img {
		height: 12px;
		width: 16px;
		margin-right: 6px;
	}
	.body-article-right-col1-img {
		height: 270px;
		width: 300px;
		border-radius: 8px 8px 0px 0px;
	}
</style>



// WEBPACK FOOTER //
// src/components/informItem.vue